<script setup lang="ts">
import { simulatorCapabilities } from '../data/landing.content'
import { useLandingScroll } from '../composables/useLandingScroll'

/**
 * Bloque B de la sección de simuladores: "qué puedes hacer".
 *
 * Ocupa el ancho completo debajo del showcase (definiciones + mockup), que
 * es donde el grid de capacidades sigue respirando en cuatro columnas.
 */
const { registerReveal } = useLandingScroll()
</script>

<template>
  <div class="wl-sim-block wl-sim-block--spaced">
    <div class="wl-sim-block-head reveal" :ref="registerReveal">
      <span class="section-tag">Qué puedes hacer</span>
      <h3 class="wl-sim-block-title">Siete formas de <span class="gradient-text">practicar</span></h3>
      <p class="wl-sim-block-desc">No es un examen y ya. El simulador se adapta a cómo quieras estudiar hoy.</p>
    </div>

    <div class="wl-sim-caps reveal" :ref="registerReveal">
      <div v-for="capability in simulatorCapabilities" :key="capability.title" class="wl-sim-cap">
        <span class="wl-sim-icon wl-sim-icon--sm">
          <svg
            width="19"
            height="19"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path v-for="(path, i) in capability.icon.split('|')" :key="i" :d="path" />
          </svg>
        </span>
        <div class="wl-sim-cap-body">
          <h5>{{ capability.title }}</h5>
          <p>{{ capability.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
